import type { DialogState } from 'lib/hooks/useDialogStore/useDialogStore'

// The caller owns the dialog id and its payload contract; the shared store cannot infer that pairing.
export const getDialogData = <T>(dialog: DialogState | undefined): DialogState<T>['data'] =>
  dialog?.data as DialogState<T>['data']
